import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DpadZoneType } from '@core/constants';
import { DeviceType } from '@core/models/enums/common.enum';
import { Menu } from '@core/models/models';
import { DetectDeviceService } from '@core/services/common/detect-device.service';
import { DpadControlService } from '@core/services/common/dpad-control.service';

@Component({
  selector: 'caremoni-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {
  @Input() isExpanded: boolean = false;
  @Input() data: Menu[] = [];
  @Output() toggleSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() handleActiveMenu = new EventEmitter();
  public currentRoute: string = '';
  DeviceType = DeviceType;
  deviceType: string = '';
  DpadZoneType = DpadZoneType;
  constructor( 
    private detectDeviceService: DetectDeviceService,
    private dpadControlService: DpadControlService,

  ) { 
    this.detectDeviceService.currentDevice.subscribe((device: any) => {
      if (device) this.deviceType = device.type;
    });
    if(dpadControlService) {
      this.dpadControlService.onSelectMenu((event: any) => {
          if(!this.isExpanded) {
            this.isExpanded = true;
          }
      });
       this.dpadControlService.onOutMenu((event: any) => {
          if(this.isExpanded) {
            this.isExpanded = false;
          }
      });
    }
  }

  ngOnInit(): void {
    this.data = this.data.filter((menu: Menu) => menu.display !== false);
  }

  handleSidebarToggle(event: any) {
    this.toggleSidebar.emit(!this.isExpanded);
    this.isExpanded = !this.isExpanded;
  }

  getMenuIcon(menu: Menu) {
    return menu.icon + '-icon';
  }

  onMenuClick(menu: Menu) {
    // Don't set active state here - let the layout handle it after successful navigation
    // This prevents UI desync when canDeactivate guard blocks navigation
    this.handleActiveMenu.emit(menu);
  }

  isActiveRoute(menu: Menu) {
    return this.currentRoute === '/' + menu.routerLink;
  }

  setLabelForMenu() {
    setTimeout(() => {
      return this.isExpanded ? 'unset' : 'none'
    }, 500);
  }
}